  function contactFormSuccess() {
    document.getElementById('contact_form').innerHTML = '<h1>Thanks for your message</h1><p>We’ll be in touch!</p>';
  }
  function contactFormFailure() {
    document.getElementById('contact_form').innerHTML = '<h1>An unexpected problem occurred</h1><p>Please contact <a href="mailto:support.it@flowgreens.com">support.it@flowgreens.com<a> and we\'ll try to figure it out.</p>';   
  }
  document.getElementById('contact_form').addEventListener('submit', async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = {
      name: form.name.value,
      email: form.email.value,
      message: form.message.value
    };

    try {
      const response = await fetch('https://subscribe.scentxpresso.com/contact-form', {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      const result = await response.json();
      if (result.success) {
          contactFormSuccess()
          return;
      }
    } catch (err) {
      console.log('Error sending message: ' + err.message);
    }
    contactFormFailure();
  });